import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconExcel = createIcon({
  viewBox: '0 0 64 64',
  path: (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="64" height="64" rx="4" fill="white" />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
        <rect
          x="17.3359"
          y="10.9433"
          width="38.8694"
          height="45.1163"
          fill="url(#pattern0)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.2">
          <path
            d="M52.3166 11.117H21.0244C19.9463 11.117 19.0723 11.991 19.0723 13.0691V50.8829C19.0723 51.9611 19.9463 52.8351 21.0244 52.8351H52.3166C53.3947 52.8351 54.2687 51.9611 54.2687 50.8829V13.0691C54.2687 11.991 53.3947 11.117 52.3166 11.117Z"
            fill="white"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.12">
        <rect
          x="18.248"
          y="10.4669"
          width="37.1341"
          height="43.381"
          fill="url(#pattern1)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.12">
          <path
            d="M52.3361 11.1171H21.0439C19.9658 11.1171 19.0918 11.9911 19.0918 13.0692V50.883C19.0918 51.9611 19.9658 52.8351 21.0439 52.8351H52.3361C53.4142 52.8351 54.2883 51.9611 54.2883 50.883V13.0692C54.2883 11.9911 53.4142 11.1171 52.3361 11.1171Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M37.3361 11.1168H21.0393C20.7836 11.1168 20.5305 11.1674 20.2944 11.2657C20.0584 11.364 19.8441 11.508 19.664 11.6895C19.4839 11.8709 19.3415 12.0862 19.2449 12.323C19.1484 12.5598 19.0997 12.8133 19.1016 13.069V21.5427H37.3361V11.1168Z"
        fill="#21A366"
      />
      <path
        d="M52.3505 11.1168H37.3262V21.5427H54.2592V13.069C54.2631 12.5575 54.0646 12.0653 53.7071 11.6996C53.3495 11.3339 52.8618 11.1244 52.3505 11.1168Z"
        fill="#33C481"
      />
      <path
        d="M54.2737 31.9686H37.3262V42.3945H54.2737V31.9686Z"
        fill="#107C41"
      />
      <path
        d="M37.3361 42.3945V31.9686H19.1016V50.8682C19.0997 51.1251 19.1489 51.3798 19.2463 51.6175C19.3437 51.8553 19.4874 52.0712 19.6691 52.2529C19.8508 52.4345 20.0667 52.5783 20.3044 52.6757C20.5422 52.7731 20.7969 52.8223 21.0538 52.8204H52.3604C52.6173 52.8223 52.872 52.7731 53.1097 52.6757C53.3474 52.5783 53.5634 52.4345 53.7451 52.2529C53.9267 52.0712 54.0704 51.8553 54.1679 51.6175C54.2653 51.3798 54.3145 51.1251 54.3125 50.8682V42.3945H37.3361Z"
        fill="#185C37"
      />
      <path
        d="M37.3212 21.5438H19.0723V31.9697H37.3212V21.5438Z"
        fill="#107C41"
      />
      <path
        d="M54.2737 21.5438H37.3262V31.9697H54.2737V21.5438Z"
        fill="#21A366"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.48">
        <rect
          x="4"
          y="17.7408"
          width="32.9696"
          height="32.6225"
          fill="url(#pattern2)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.48">
          <path
            d="M30.1537 20.2414H10.5889C9.51072 20.2414 8.63672 21.1154 8.63672 22.1935V41.7584C8.63672 42.8365 9.51072 43.7105 10.5889 43.7105H30.1537C31.2318 43.7105 32.1058 42.8365 32.1058 41.7584V22.1935C32.1058 21.1154 31.2318 20.2414 30.1537 20.2414Z"
            fill="white"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.24">
        <rect
          x="7.84375"
          y="19.8513"
          width="25.3345"
          height="24.9875"
          fill="url(#pattern3)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.24">
          <path
            d="M30.1654 20.2415H10.6006C9.52244 20.2415 8.64844 21.1155 8.64844 22.1936V41.7584C8.64844 42.8366 9.52244 43.7106 10.6006 43.7106H30.1654C31.2436 43.7106 32.1176 42.8366 32.1176 41.7584V22.1936C32.1176 21.1155 31.2436 20.2415 30.1654 20.2415Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M30.1537 20.2415H10.5889C9.51072 20.2415 8.63672 21.1155 8.63672 22.1937V41.7585C8.63672 42.8366 9.51072 43.7106 10.5889 43.7106H30.1537C31.2318 43.7106 32.1058 42.8366 32.1058 41.7585V22.1937C32.1058 21.1155 31.2318 20.2415 30.1537 20.2415Z"
        fill="#107C41"
      />
      <path
        d="M14.752 38.3174L18.8153 31.9694L15.0412 25.6213H18.0778L20.1312 29.6702C20.3192 30.0461 20.4493 30.3353 20.5216 30.5233C20.6518 30.2197 20.7964 29.916 20.941 29.6268L23.1389 25.6213H25.9298L22.0833 31.9694L26.0455 38.3753H23.1534L20.7675 33.936C20.659 33.7466 20.5671 33.5482 20.4927 33.3431C20.4236 33.5458 20.3314 33.7399 20.218 33.9215L17.644 38.3174H14.752Z"
        fill="white"
      />
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.5">
        <path
          style={{ mixBlendMode: 'soft-light' }}
          opacity="0.5"
          d="M30.1537 20.2415H10.5889C9.51072 20.2415 8.63672 21.1155 8.63672 22.1937V41.7585C8.63672 42.8366 9.51072 43.7106 10.5889 43.7106H30.1537C31.2318 43.7106 32.1058 42.8366 32.1058 41.7585V22.1937C32.1058 21.1155 31.2318 20.2415 30.1537 20.2415Z"
          fill="url(#paint0_linear_1238_181272)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1238_181272"
            transform="scale(0.00884956 0.00763359)"
          />
        </pattern>
        <pattern
          id="pattern1"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image1_1238_181272"
            transform="scale(0.00925926 0.00793651)"
          />
        </pattern>
        <pattern
          id="pattern2"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image2_1238_181272"
            transform="scale(0.0104167 0.0105263)"
          />
        </pattern>
        <pattern
          id="pattern3"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image3_1238_181272"
            transform="scale(0.0135135 0.0136986)"
          />
        </pattern>
        <linearGradient
          id="paint0_linear_1238_181272"
          x1="12.7145"
          y1="18.7087"
          x2="28.028"
          y2="45.229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="1" stopOpacity="0.7" />
        </linearGradient>
        <image
          id="image0_1238_181272"
          width="113"
          height="131"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACDCAYAAAC6JPTCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0ElEQVR4Xu3YTU8TURiG4fsUbIsf+BWJGnXBwhh3/v8fYmKMGGPUGEXkS6jOHBfvOe1UxrKxRZ48d3JS6ExZcPGemSHlnHGXu/XzTgBIKaX65cIT3b8uA+RzJi0tOl7wBmWtlVdDrqYMtEBTXtu/YfYiFrxETOoQGJc1IjANudwygXcKnJQ1AX4RgzmHdgaxM31D4BpwE7gL3AGul/c9kcurTuAEOAR2ga/AHnBc3p+byrlrYgdwTODdBx4DT4AHwO1ybA23zBpi+r4BH4B3ZX0E9okJ7UckpmsIbBJ4z8raJkA3iS11gFtmLQG1T8C9JnZFiC21SSn9rNM4RSxTuAZsAFvAU+AF8Bx4xGwK1/FWuuwygXVCXMqul/ePgAMCuCnrzCQOmCFuE5Db5QdtMLtDdcuvJX7nw/L9AfCprO/AaUqpzTnnLmKdxBGxbW6VdQu4ClzBE7jK6qPdNWKIHpZ1h7hOHhLTemaq6mPFiICrfwl+rLiY6vP5mBis28ANZvclqZ70Z3Ui/YD/fzRgNlhjeoZq0fXNcP9P3f+cnRkq36RcrnoHy4gCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGfFylfveXITY+wF3IWWg7aw5mz7EDDTl5Ppq0Iup4v0CToGT8trQMVnv+VD9wDHwA5gAo3I84VZZS/z+j4A9YBc4JHymw9VFrBN4CuwDn8u6WY4P8TV0ldWBOgI+Au+A98BXYriaeuKfk9iWEz4Db5gBbgEbwBpuVbXEQO0RgC+BHeALsa22Oef5Scw555RSwwzxVTn0nUC8ihFXWUNg7RITuAO8JVAnBDIAqWDGNyklYsscA5sE3j1iIkflmK+Ly6/e0EyAAwLyCwF4DPzMOfcjwhzkkNhCNwjAdQy4yuo1cULsjifl66YLCD2IMIVMxPY5KK8GXH11Iuuj3vQ62K0XcXowMMGAF1mGuGf52wkLEd3l6DfHVuwii6DFdAAAAABJRU5ErkJggg=="
        />
        <image
          id="image1_1238_181272"
          width="108"
          height="126"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB+CAYAAADBePRdAAAACXBIWXMAAC4jAAAuIwF4pT92AAACb0lEQVR4Xu3XzXHaUBhG4XMJSxtKIAWkhbiANOAC0lN6SAMU4GxcAAVACYC38ZeFJFvDzzKId+acjcTVZfXMJy6tqjittTY7W7SbVVXv1561MVhrrQELYAU8AO3K9+z/VMAbsAOOl+A+wHqsJfAdeKZDE+y2FR3WGtgA26o6jDe0qhpjPQE/++sCm6IjsAVegV/AZjxp8/66oJusAWuJ0zVVS+Bbf/9CN3H74eGsP2Cs6F6DYt1HX4CvwA9gNT4EDjePdGgLxLqXBpPH8eL4+C7U/XVm4v+tsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLawxWV3fZVJ2ZDGBHYAccLm2ySRpMjuPFWVW99w9+Ay/AHtGm7i+wBdbArjcCYN5fD8AfoPWfn4AFNkVHOqxXYMPJhM0Bqqpaa3u6Cat+04pPQLtNRfe2W9NhbcfTBdCqPt9+rbVGN1kr4AHBbl0Bb/S/XadYcAL2sdiax/0JuwQ1dBHM7rd/jp90H8g9bqAAAAAASUVORK5CYII="
        />
        <image
          id="image2_1238_181272"
          width="96"
          height="95"
          xlinkHref="data:image/png;base64,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"
        />
        <image
          id="image3_1238_181272"
          width="74"
          height="73"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABJCAYAAACaRLDfAAAACXBIWXMAAC4jAAAuIwF4pT92AAABy0lEQVR4Xu3cMVLCUBSF4f8ylKI7EHvXoDuwdwOuTXtXIKyB3rgDwZpncfMMJOCcmnf+hglkmMk3ScoTpRRqERHAAlgCV0DQRgX4ATpgVw5R+qJ+1yNdA4/AM4nVElQHvAErYDvGmsME6QV46I9b6p58mgBWEXGENe8/FwxIjyRSK3dT7Ya89toHsK0H84iYkY/ZM8Od1BoS5DVfkwY74DMiNqWUPcCsP6m+wFtFqlWsJcNjCAxQ9SSXTSwOodw/GUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlK7BBqMi7VcBOLCrUjh6a2p05qqEIadKTJX7N+9qeuca2Bb2A//ocG2pPXviYtujqJBMPQ1o6cLIPcervnxDTQBVefqA3wSloc3VHjjbsFcEdCPQG3XP5cUgG+gHcS6pMTg4AxOqZfKFuQSC0sJ9bFxC8S6ORrZwL190OCNdM5oNpZKHfcL4k/bZY4tSNlAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  ),
});

export default IconExcel;
